<template>
  <div class="panel__content__element">
    <div class="g-handle" />
    <accordion-element-component
      class="g-grey-box"
      :disabled="computedDisabled"
      v-bind="{
        Data: {
          icon: [
            'custom',
            'sensors'
          ],
          title: 'Moisture',
          subTitle: computedMoistureStatusTitle
        }
      }"
    >
      <moisture-component
        :store="store"
        :moisture="moisture"
      />
    </accordion-element-component>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty'

import AccordionElement from '@/components/elements/AccordionElement'
import MoistureComponent from '@/components/MoistureComponent.vue'

export default
{
  name: 'AccordionMoisture',
  components:
  {
    'moisture-component': MoistureComponent,
    'accordion-element-component': AccordionElement
  }, // Available in this.$options.name
  props: {
    moisture: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  computed: {
    computedDisabled() {
      return !(this.moisture && this.moisture.list && this.moisture.list.length)
    },
    computedMoistureStatusTitle() {
      let rtnString = this.$t('messages.moisture.noMoistureSensorsDetected')
      let sensorsWithIssues = []

      if(this.moisture && this.moisture !== null && this.moisture !== undefined && this.moisture.list && this.moisture.list.length) {
        sensorsWithIssues = this.moisture.list.filter(item => item.state !== 4)
     
        if(sensorsWithIssues.length === 0) {
          rtnString = this.$t('messages.moisture.allNominal')
        } else {
          const plural = sensorsWithIssues.length > 1 ? 0 : 1
          rtnString = `<span class="red">${this.$tc('messages.moisture.programSensorsOutsideLimits', plural, {count: sensorsWithIssues.length})}</span>`
        }
      }

      return rtnString
    }
  },
  methods: {
    returnFillColor(state) {
      const states = {
        1: 'grey',
        2: 'red',
        3: 'yellow',
        4: 'green',
        5: 'blue'
      }

      return states[state]
    }
  }
}
</script>

<style lang="scss">
</style>
